<template>
  <LayoutGradient :title="$t('dexpara.complement.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaSimpleFilter @search="searchComplements"/>

        <TableSimple
            :fields="fields"
            :items="complements"
            :loading="complementsIsLoading || DeXParaIsLoading"
            :paginator="pagination"
            :text-empty="$t('dexpara.complement.empty')"
            thead-class="h5 text-center"
            @paginate="paginateComplements"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <b-form-group :label="linha.item.name">
              <b-form-input
                  :id="'input-origem-' + linha.index"
                  :disabled="Object.keys( integrationsSelected.origin ).length === 0"
                  v-model="linha.item.origin_code"
                  trim
              />
              <b-button size="sm" variant="link" @click="openLogs(linha);" class="mb-0 p-0" v-if="permissions.includes('logs.detail')">
                {{ $t('dexpara.filtros.logs') }}
              </b-button>
            </b-form-group>
          </template>
          <template v-slot:cell(destination)="{item, index}">
            <b-form-group :label="item.name">
              <b-form-input
                  :id="'input-destino-' + index"
                  :disabled="Object.keys( integrationsSelected.destination ).length === 0"
                  v-model="item.destination_code"
                  trim
              />
            </b-form-group>
          </template>
          <template #row-details="{ item, index }">            
            <b-card :title="$t('dexpara.log.origem')">
              <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
            </b-card>
            <b-card :title="$t('dexpara.log.destino')" class="mt-2">
              <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
            </b-card>
          </template>
        </TableSimple>
      </b-card>

      <DeXParaIntegrations class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara"/>

    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaSimpleFilter from "@/pages/dexpara/components/DeXParaSimpleFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import DeXParaRepository from "@/repositories/dexpara/ComplementRepository";
import {mapActions, mapGetters} from 'vuex';
import DeXParaIntegrations from "@/pages/dexpara/components/DeXParaIntegrations";
import TableSimple from "@/components/TableSimple";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaComplement",
  components: {
    TableSimple,
    DeXParaIntegrations,
    DeXParaSimpleFilter,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      DeXPara: 'dexpara/complement/all',
      DeXParaIsLoading: 'dexpara/complement/isLoading',

      complements: 'tuevs/complement/all',
      complementsIsLoading: 'tuevs/complement/isLoading',
      pagination: 'tuevs/complement/pagination',
      filters: 'dexpara/filters'
    }),
  },
  data() {
    return {
      integrationsSelected: {
        origin: {},
        destination: {}
      },
      fields: [
        {key: 'origin', label: this.$t('dexpara.complement.origem')},
        {key: 'destination', label: this.$t('dexpara.complement.destino')}
      ],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'dexpara/complement/listAll',
      'tuevs/complement/listAll',
      'integration/search'
    ]),
    async openLogs(linha) {
      if (linha.detailsShowing === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);
      }      

      linha.toggleDetails();
    },
    async formatLogDetails(specimenComplement) {
      let obj = {}
      let logOrigin = null
      let logDestination = null
      if (!this.DeXPara || this.DeXPara.length === 0) {
        return obj
      }

      let originMapped = this.DeXPara.filter(d => d.tuevs_specimen_complement_id === specimenComplement.id && d.code === specimenComplement.origin_code);
      let destinationMapped = this.DeXPara.filter(d => d.tuevs_specimen_complement_id === specimenComplement.id && d.code === specimenComplement.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].id).then(async (response) => {          
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateComplements(pagination) {
      await this.$store.commit('tuevs/complement/setPagination', {
        ...this.pagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchComplements()
    },
    async searchComplements() {
      let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code_mapping");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin.value, this.integrationsSelected.destination.value]]);
        }
      }

      await this['tuevs/complement/listAll']({...this.pagination, filters: filterApi})
      await this.searchDeXparas()
      this.loadIntegrationsCodes()
    },
    async searchDeXparas() {
      let filters = [
        [
          'tuevs_specimen_complement_id',
          'IN',
          this.complements.reduce((total, current) => [...total, current.id], [])
        ],
        [
          'vns_integration_id',
          'IN',
          [this.integrationsSelected.origin.value, this.integrationsSelected.destination.value]
        ]
      ]
      if (this.integrationsSelected.origin.value || this.integrationsSelected.destination.value){
        await this['dexpara/complement/listAll']({
          per_page: this.pagination.per_page * 2,
          filters: JSON.stringify(filters)
        })
      }
    },
    getDeXpara(tuevs_specimen_complement_id, integration_id) {
      if (this.DeXPara && Array.isArray(this.DeXPara)) {
        return  this.DeXPara.find(complement => {
          return complement.vns_integration_id === integration_id && complement.tuevs_specimen_complement_id === tuevs_specimen_complement_id
        })
      }
      return null
    },
    loadIntegrationsCodes() {
      if (this.complements && Array.isArray(this.complements)) {
        const complements = this.complements.map(complement => {
          if (Object.keys(this.integrationsSelected.origin).length > 0) {
            const origin_mapped = this.getDeXpara(complement.id, this.integrationsSelected.origin.value)
            complement.origin_code = origin_mapped && origin_mapped.code ? origin_mapped.code : null
          }

          if (Object.keys(this.integrationsSelected.destination).length > 0) {
            const destination_mapped = this.getDeXpara(complement.id, this.integrationsSelected.destination.value)
            complement.destination_code = destination_mapped && destination_mapped.code ? destination_mapped.code : null
          }

          return complement
        })
        this.$store.commit('tuevs/complement/setAll', complements)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected = evt

      if (Object.keys(this.integrationsSelected.origin).length > 0) {
        this.fields = [
          {key: 'origin', label: this.integrationsSelected.origin.label},
          this.fields.find(obj => obj.key !== 'origin')
        ]
      }
      if (Object.keys(this.integrationsSelected.destination).length > 0) {
        this.fields = [
          this.fields.find(obj => obj.key !== 'destination'),
          {key: 'destination', label: this.integrationsSelected.destination.label}
        ]
      }
      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async persistDeXPara() {
      let parsedIntegrations = []
      let integrationOriginId = this.integrationsSelected.origin.value
      let integrationDestinationId = this.integrationsSelected.destination.value

      if (integrationOriginId) {
        this.complements.filter(c => c.origin_code !== null)
            .map(complement => {
              let dexpara = {
                tuevs_specimen_complement_id: complement.id,
                integrations: [{id: integrationOriginId, code: complement.origin_code}]
              }
              if (this.getDeXpara(complement.id, integrationOriginId) && complement.origin_code === '') {
                dexpara = {...dexpara, integrations: [integrationOriginId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (integrationDestinationId) {
        this.complements.filter(c => c.destination_code !== null)
            .map(complement => {
              let dexpara = {tuevs_specimen_complement_id: complement.id, integrations: [{id: integrationDestinationId, code: complement.destination_code}]}
              if (this.getDeXpara(complement.id, integrationDestinationId) && complement.destination_code === '') {
                dexpara = {...dexpara, integrations: [integrationDestinationId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (parsedIntegrations.length > 0) {
        await DeXParaRepository.post({complement: parsedIntegrations}).then(async () => {
          await this['dexpara/complement/listAll']()
          this.$snotify.success(this.$t('dexpara.complement.sucesso'))
          await this.searchComplements()
        })
      }
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    this.$store.commit('tuevs/complement/setPagination', {...this.pagination, page: 1})
    await this['tuevs/complement/listAll'](this.pagination)
    await this['integration/search']()
    await this.searchDeXparas()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}
</style>
